// `prefer` picks which entity to check first when an account holds BOTH (a dual-usertype
// account, e.g. an Institutional account that separately registered a Company) - confirmed live
// this always used to default to fpoEntity regardless of caller, so MyBusiness's own
// ProfileWidget.jsx fed a dual-usertype account's fpoEntity.id into getCompanyById(), 404ing
// with "Unable to load your profile." every time.
//
// Explicit callers (ProfileWidget.jsx, MemberPost.jsx, etc.) pass "company"/"fpo" directly.
// Everything else - and this turned out to be the vast majority: Vendor/Product/Purchase/Sales/
// Bank/CashBook Post+Update, every statutory-compliance form, ShareCapitalPost.jsx, etc. - is a
// single component tree shared verbatim between the MyFPO and MyBusiness routes in routes.js
// (imported once, rendered under both `/myFpo/...` and `/mybusiness/...`). Patching every one of
// those ~90 call sites individually is exactly how this bug slipped through the first time
// (ShareCapitalPost.jsx already HAD its own isBusiness flag and still resolved the wrong id here,
// because the id resolution and the business/fpo branch had drifted apart). So when no explicit
// `prefer` is given, infer it from the current route instead - reliable because every one of
// these shared components only ever renders under one or the other route prefix, never both at
// once, and it fixes every existing and future shared-component call site with no per-file
// changes at all.
export const resolveOrganizationId = (fullUserData, prefer) => {
  if (!fullUserData) return null;

  const effectivePrefer = prefer
    || (typeof window !== "undefined" && window.location?.pathname?.startsWith("/mybusiness") ? "company" : "fpo");

  const fpoId = fullUserData?.fpoEntity?.id;
  const companyId = fullUserData?.companyEntity?.id;
  const [first, second] = effectivePrefer === "company" ? [companyId, fpoId] : [fpoId, companyId];
  if (first) return first;
  if (second) return second;

  // A member (fpo_member/business_member) has no fpoEntity/companyEntity of their own - their
  // org id lives on membershipEntity.tenantId instead (same convention as CompanyResPayload/
  // CapacityBuildingResponse/etc. - see ComplianceTenantResolver), set by UserServiceImpl.getUser()
  // regardless of which kind of member this is.
  return fullUserData?.membershipEntity?.tenantId || null;
};
